import { inject, Injectable, untracked } from '@angular/core';
import { Command, CommandRepository } from '@okcargo/command-processor';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../api/api.service';
import { ConnectivityService, OfflineError } from '../connectivity';

@Injectable({ providedIn: 'root' })
export class BaseCommandRepository implements CommandRepository {
  private readonly apiService = inject(ApiService);
  private readonly connectivity = inject(ConnectivityService);

  private readonly _baseUrl = '/service/command-processor/api/commands';

  // constructor() {}

  execute(_name: string, command: Command): Promise<any> {
    // untracked, as in the query repository: executing a command from a reactive context must not
    // make that context depend on the connectivity status.
    if (untracked(() => this.connectivity.isOffline())) {
      return Promise.reject(new OfflineError(`Command "${_name}" was not sent to the backend.`));
    }

    const baseUrl = this._baseUrl;
    return firstValueFrom(this.apiService.post(baseUrl, { name: _name, payload: command }, { observe: 'body' }));
  }
}
